import store from '@/store'
import { Message, MessageBox } from 'element-ui'

var websock = null // 与后台建立的websocket连接 用于保持心跳
let reconnectElMessage = null // ws重连消息框
var heartResponseTime = new Date()

function initWebSocket() { // 初始化weosocket
  // ws地址
  const protocol = window.location.protocol == 'https:' ? 'wss:' : 'ws:'
  const host = window.location.host
  const pathname = window.location.pathname
  var wsuri = `${protocol}//${host}${pathname}ws/app?token=${store.getters.token}`

  if(websock){
    websock.close(4000, '重连关闭原有ws')
    websock = null
  }

  websock = new WebSocket(wsuri)
  websock.onopen = websocketOpen
  websock.onmessage = websocketonmessage
  websock.onclose = websocketclose
  websock.onerror = websocketError
  heartResponseTime = new Date()
  startHeartbeat()
}

// ws连接成功
function websocketOpen(e) {
  console.log(new Date().toLocaleString(),'与云坐席后台 websocket 连接成功')
  closeWebsocketWarning()
  Message.success({ message: '服务连接成功' })
}

// ws收到数据
function websocketonmessage(e) {
  const message = JSON.parse(e.data)
  if (message.messageType == 6) {
    heartResponseTime = new Date()
  }
}

// ws连接关闭
function websocketclose(e) {
  console.log(new Date().toLocaleString(),'与云坐席后台 websocket 断开连接.',e)
  closeWebsocketWarning()

  if (e.code == 1002) {
    reconnectElMessage = Message.warning({
      message: '连接异常 - ' + e.code + e.reason,
      duration: 0
    })
  } else if (e.code == 1008) {
    MessageBox.alert(`登录超时，请重新登录。`, '登录超时', {
      confirmButtonText: '确定',
      type: 'warning',
      dangerouslyUseHTMLString: true,
      showClose: false
    }).then(() => {
      location.href = '#/login'
      location.reload()
    })
  } else {
    reconnectElMessage = Message.warning({
      message: '连接中断 - ' + e.code + e.reason,
      duration: 0
    })
    reconnect()
  }
}

// ws连接异常
function websocketError(e) {
  console.log(new Date().toLocaleString(),'与云坐席后台 websocket 连接失败',e)
}


function closeWebsocketWarning() {
  if (reconnectElMessage) {
    try {
        reconnectElMessage.close()
    } catch (error) { }
  }
}

// 启动心跳检测
const heartDuration = 10 * 1000 // 心跳频率
var heartInterval = null // 心跳定时器]
var checkHeartTime = new Date()
function startHeartbeat() {
  if(heartInterval) {
    return
  }

  heartInterval = setInterval(function () {
    if(reconnectTimeout) {
      return
    }

    if((checkHeartTime-heartResponseTime)>60*1000) {
      reconnect()
      return
    }

    checkHeartTime = new Date()
    if (websock && websock.readyState == WebSocket.OPEN) { // 如果连接正常
      const heartbeatData = {
        'messageId': '00000',
        'cmdType': 'Heart',
        'data': {}
      }
      websock.send(JSON.stringify(heartbeatData))
    }
  }, heartDuration)
}

// 重新连接
var reconnectTimeout = null // 心跳定时器
function reconnect() {
  reconnectTimeout = setTimeout(() => {
    clearTimeout(reconnectTimeout)
    reconnectTimeout = null
    initWebSocket()
  }, 5*1000);
}

export { initWebSocket }


// WEBPACK FOOTER //
// ./src/utils/socket.js